
import {AuthenticationService} from '../services/authentication.service';

export function appInitializer(authenticationService: AuthenticationService) {
  return () => authenticationService.refreshToken();
}
